<div class="input-wrapper collapsed" #expandable>
    <div class="template-container">
        <div class="input-header">
            <div class="title">
                From Templates
            </div>
        </div>
        <div class="template-picker">
            <div class="template">
                <div class="template-description">Dolorem sed aperiam voluptatem autem et.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/slide-images/output/1000/modern-slide-bnr2_2000x.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Minima ut facilis.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/slide-images/output/1000/modern-slide-bnr1_2000x.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Consequuntur quo illo nam molestiae quia.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/preservedfood/output/1200/pexels-roman-odintsov-5855875.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Animi id quis qui et quos et saepe.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/preservedfood/output/1200/pexels-nastyasensei-821365.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Vero exercitationem nostrum sed voluptatem accusantium dolor rerum voluptate.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/succulents/output/1200/pexels-matzi-8260060.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Ut dolor doloribus esse similique iusto.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/succulents/output/1200/pexels-ylanite-koppens-1906439.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Dolorum provident voluptas.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/craft/output/1200/pexels-jadson-thomas-542556.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Nesciunt natus aliquam quasi.</div>
                <div class="template-preview">
                    <div class="img-container">
                        <img src="http://kwikstore-dev/assets/craft/output/1200/pexels-tim-mossholder-668295.jpg"/>
                    </div>
                </div>
            </div>
            <div class="template">
                <div class="template-description">Template 9</div>
                <div class="template-preview">Preview 9</div>
            </div>
            <div class="template">
                <div class="template-description">Template 10</div>
                <div class="template-preview">Preview 10</div>
            </div>
            <div class="template">
                <div class="template-description">Template 11</div>
                <div class="template-preview">Preview 11</div>
            </div>
            <div class="template">
                <div class="template-description">Template 12</div>
                <div class="template-preview">Preview 12</div>
            </div>
        </div>
    </div>
    <div class="input-container">
        <kve-input-header [title]="title" (onClose)="close($event)"></kve-input-header>
        <!-- <div class="input-header">
            <div class="title">
                Add New Grid
            </div>
            <div class="close-button">
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action> 
            </div>
        </div> -->
        <div class="input-cell">
            <nb-actions>
                <nb-action>
                    <nb-icon [icon]="collapsed ? 'arrowhead-left-outline' : 'arrowhead-right-outline'"
                        pack="eva" pack="eva" (click)="toggleContainer()">
                    </nb-icon>
                </nb-action>
                <nb-action>
                    Templates
                </nb-action>
            </nb-actions>
        </div>
        <div class="input-cell">
            <div class="description">Three Cells over 1 or 2 rows</div>
            <div class="graphic cell-3" (click)="createGrid(3)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- Define the grid -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                  </svg>
   
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Four Cells over 2 rows</div>
            <div class="graphic cell-4" (click)="createGrid(4)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- Cell spanning two rows in the first column -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Two cells in the second column -->
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="32" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Cell spanning two rows in the last column -->
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                  </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Five Cells over 2 rows</div>
            <div class="graphic cell-5" (click)="createGrid(5)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- Cell spanning two rows in the first column -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                  
                    <!-- Two cells in the second column -->
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="32" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Two cells in the third column -->
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="32" width="44" height="28" fill="none" stroke="#fff" stroke-width="1.25"/>
                  </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Six Cells over 2 or 3 rows.</div>
            <div class="graphic cell-6" (click)="createGrid(6)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="42" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="20" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="48" y="24" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="20" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="96" y="24" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="0" y="46" width="140" height="14" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Seven Cells over 2 or 3 rows.</div>
            <div class="graphic cell-7" (click)="createGrid(7)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- Cell spanning three rows in the first column -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    
                    <!-- Two cells in the second column -->
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="48" y="22" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="48" y="44" width="44" height="16" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    
                    <!-- Three cells in the third column -->
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="96" y="22" width="44" height="18" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                    <rect class="grid-option-rec" x="96" y="44" width="44" height="16" fill="none" stroke="#fff" stroke-width="1.25"></rect>
                </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Eight Cells over 3 or 4 rows.</div>
            <div class="graphic cell-8" (click)="createGrid(8)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- First column: Cell spanning three rows -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="44" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <!-- First column: Second cell -->
                    <rect class="grid-option-rec" x="0" y="48" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Second column: Cell spanning three rows -->
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="44" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <!-- Second column: Second cell -->
                    <rect class="grid-option-rec" x="48" y="48" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Cells in the third column -->
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="16" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="32" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="48" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                  </svg>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Nine Cells over 3 or 4 rows.</div>
            <div class="graphic cell-9" (click)="createGrid(9)">
                <svg width="140" height="60" xmlns="http://www.w3.org/2000/svg">
                    <!-- First column: Cell spanning four rows -->
                    <rect class="grid-option-rec" x="0" y="0" width="44" height="60" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Four cells in the second column -->
                    <rect class="grid-option-rec" x="48" y="0" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="16" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="32" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="48" y="48" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    
                    <!-- Four cells in the third column -->
                    <rect class="grid-option-rec" x="96" y="0" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="16" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="32" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                    <rect class="grid-option-rec" x="96" y="48" width="44" height="12" fill="none" stroke="#fff" stroke-width="1.25"/>
                  </svg>
            </div>
        </div>
    
    </div>
</div>

